import { useState } from 'react';
import {
    FormControl,
    Stack,
    FormLabel,
    Box,
    Text,
    VStack,
} from '@chakra-ui/react';
import DropDown from 'components/forms/new/formikFormFields/DropDown';
import FieldToolTip from 'components/forms/new/FieldToolTip';
import {
    stackSpacing,
    formLabelStyling,
    stackStyling,
    descriptionStyling,
} from 'components/forms/new/formStyles';

const EightByEightServiceProviderField = ({
    value,
    onChange,
    options,
    darkMode,
    error,
    showError,
}) => {
    const [isHovered, setIsHovered] = useState(false);
    const providerOptions = (options || []).map((opt) => ({
        id: opt.value,
        name: opt.label,
    }));

    return (
        <FormControl
            sx={{ margin: '0 !important' }}
            isInvalid={!!error && showError}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}>
            <Stack
                direction="row"
                spacing={stackSpacing}
                sx={stackStyling(true)}>
                <Box>
                    <FormLabel sx={formLabelStyling(darkMode)}>
                        Service Provider{' '}
                        <span style={{ color: '#e53e3e' }}>*</span>
                    </FormLabel>
                    <Text sx={descriptionStyling} maxWidth={250}>
                        Select the service provider for this profile.
                    </Text>
                </Box>
                <Box flex="1" minWidth="450px">
                    <Box
                        sx={{
                            display: 'flex',
                            width: '100%',
                            alignItems: 'flex-start',
                            paddingTop: '15px',
                        }}>
                        <VStack width="100%" alignItems="normal">
                            <DropDown
                                field={{
                                    name: 'serviceProviderID',
                                    value,
                                }}
                                data={providerOptions}
                                shownValue="name"
                                placeholder="Select a service provider"
                                darkMode={darkMode}
                                width="100%"
                                noPadding
                                handleSelectChange={(item) =>
                                    onChange(item?.id ?? null)
                                }
                            />
                            {showError && error && (
                                <Text
                                    color="red.500"
                                    fontSize="xs"
                                    mt={1}
                                    textAlign="right">
                                    {error}
                                </Text>
                            )}
                        </VStack>
                    </Box>
                </Box>
                {isHovered && (
                    <FieldToolTip
                        label="Select the service provider for this profile."
                        ariaLabel="eightbyeight-service-provider-tip"
                        left="25px"
                        top="25px"
                    />
                )}
            </Stack>
        </FormControl>
    );
};

export default EightByEightServiceProviderField;
